import { render, staticRenderFns } from "./FichesResultatsList.vue?vue&type=template&id=fa0a1c44&"
import script from "./FichesResultatsList.vue?vue&type=script&lang=js&"
export * from "./FichesResultatsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports